/* src/app/bot/ai/ai.component.scss */
*,
*::before,
*::after {
  box-sizing: border-box;
}
* {
  margin: 0;
  padding: 0;
}
html {
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
}
body {
  min-height: 100vh;
  text-rendering: optimizeLegibility;
  line-height: 1.5;
}
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}
input,
button,
textarea,
select {
  font: inherit;
}
button {
  background: none;
  border: none;
  cursor: pointer;
}
a {
  color: inherit;
  text-decoration: none;
}
ul,
ol {
  list-style: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}
#root,
app-root {
  isolation: isolate;
  min-height: 100vh;
}
textarea {
  resize: vertical;
}
:disabled {
  cursor: not-allowed;
}
@font-face {
  font-family: "Outfit-Bold";
  src: url("./media/Outfit-Bold.ttf");
}
@font-face {
  font-family: "Outfit-Medium";
  src: url("./media/Outfit-Medium.ttf");
}
@font-face {
  font-family: "Outfit-Regular";
  src: url("./media/Outfit-Regular.ttf");
}
@font-face {
  font-family: "Outfit-Light";
  src: url("./media/Outfit-Light.ttf");
}
h1 {
  font: 900 32px/1.6 "Outfit-Regular";
  letter-spacing: 0.75px;
}
h2 {
  font: 100 30px/1.6 "Outfit-Regular";
}
h3 {
  font: 800 18px/1.6 "Outfit-Regular";
}
h4 {
  font: 600 14px/1.6 "Outfit-Regular";
}
h5 {
  font: 700 15px/1.6 "Outfit-Regular";
}
h6 {
  font: 100 14px/1.6 "Outfit-Regular";
}
h1,
h2,
h3,
h4,
h5,
h6 {
  width: 100%;
  font-weight: normal;
}
label {
  margin-bottom: 0.2rem !important;
}
p,
li,
label,
.form-control,
.form-select {
  font: 500 15px/24px "Outfit-Regular";
}
ul {
  list-style: none;
}
li {
  line-height: 18px;
}
html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
  color: var(--text-week);
  font-family: "Outfit-Regular";
  font-size: 14px;
  background-color: var(--surface-a) !important;
}
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 4px;
  background-color: var(--surface-a);
}
::-webkit-scrollbar-thumb {
  background-color: var(--scroll-bar-thumb);
}
:host {
  --primary: #253b80;
  --primary-dark: #1e316b;
  --primary-light: #eef2ff;
  --primary-soft: #f5f7ff;
  --secondary: #344f91;
  --user-bg: #eef2ff;
  --user-border: #d8e0f5;
  --bot-bg: #ffffff;
  --bot-border: #e5e7eb;
  --text-dark: #111827;
  --text-primary: #253b80;
  --text-body: #374151;
  --text-secondary: #6b7280;
  --text-muted: #9ca3af;
  --border: #e5e7eb;
  --border-light: #eef0f4;
  --page-bg: #f4f6fa;
  --success: #16a34a;
  --danger: #dc2626;
  --shadow-sm: 0 2px 8px rgba(15, 23, 42, 0.05);
  --shadow-md: 0 6px 20px rgba(15, 23, 42, 0.07);
  display: block;
  width: 100%;
  box-sizing: border-box;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
.chat-wrapper {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 18px 20px;
  box-sizing: border-box;
}
.chat-row {
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
  gap: 12px;
  margin-bottom: 26px;
  box-sizing: border-box;
}
.chat-row.user {
  justify-content: flex-end;
}
.chat-row.bot {
  justify-content: flex-start;
}
.avatar {
  width: 38px;
  height: 38px;
  min-width: 38px;
  flex: 0 0 38px;
  overflow: hidden;
  border-radius: 50%;
  background: var(--primary-light);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}
.avatar img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.chat-block {
  width: auto;
  max-width: calc(100% - 50px);
  min-width: 0;
  box-sizing: border-box;
}
.chat-card {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  color: var(--text-body);
  overflow-wrap: anywhere;
  word-break: break-word;
}
.user-card {
  width: fit-content;
  max-width: min(760px, 100%);
  margin-left: auto;
  padding: 4px 17px;
  background: var(--user-bg);
  border: 1px solid var(--user-border);
  border-radius: 18px 18px 5px 18px;
  color: var(--text-dark);
  font-size: 16px;
  font-weight: 500;
  line-height: 1.65;
  box-shadow: var(--shadow-sm);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.user-card:hover {
  border-color: #c7d2fe;
  box-shadow: var(--shadow-md);
}
.user-card:hover .question-actions {
  opacity: 1;
  visibility: visible;
}
.user-card .question-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}
.bot-card {
  width: 100%;
  padding: 17px 20px;
  min-width: 0;
}
.question-text {
  flex: 1;
  min-width: 0;
  color: var(--text-dark);
  font-size: 16px;
  line-height: 1.65;
  font-weight: 500;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.question-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 5px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
}
.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  min-width: 34px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 50%;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.icon-btn i {
  font-size: 15px;
}
.icon-btn:hover {
  background: #ffffff;
  border-color: var(--border);
  color: var(--primary);
}
.icon-btn:active {
  transform: scale(0.94);
}
.answer {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  color: var(--text-body);
  font-size: 16px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.answer > :first-child {
  margin-top: 0 !important;
}
.answer > :last-child {
  margin-bottom: 0 !important;
}
.answer {
}
.answer p {
  margin: 0 0 12px;
  color: var(--text-body);
  font-size: 16px;
  line-height: 1.8;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.answer {
}
.answer h1,
.answer h2,
.answer h3,
.answer h4,
.answer h5,
.answer h6 {
  max-width: 100%;
  color: var(--text-dark);
  overflow-wrap: anywhere;
  word-break: break-word;
}
.answer h1 {
  margin: 1.5rem 0 0.85rem;
  font-size: 1.5rem;
  line-height: 1.3;
  font-weight: 700;
}
.answer h2 {
  margin: 1.35rem 0 0.75rem;
  font-size: 1.3rem;
  line-height: 1.35;
  font-weight: 700;
}
.answer h3 {
  margin: 1.2rem 0 0.65rem;
  font-size: 1.15rem;
  line-height: 1.4;
  font-weight: 650;
}
.answer h4 {
  margin: 1rem 0 0.5rem;
  font-size: 1.05rem;
  line-height: 1.45;
  font-weight: 650;
}
.answer h5,
.answer h6 {
  margin: 0.9rem 0 0.45rem;
  font-size: 1rem;
  line-height: 1.45;
  font-weight: 600;
}
.answer {
}
.answer br {
  line-height: 1.6;
}
.answer {
}
.answer ul,
.answer ol {
  width: 100%;
  max-width: 100%;
  margin: 0.8rem 0 1rem;
  padding-left: 1.7rem;
  box-sizing: border-box;
  white-space: normal;
}
.answer ul {
  list-style-type: disc;
}
.answer ol {
  list-style-type: decimal;
}
.answer li {
  margin: 0.4rem 0;
  padding-left: 0.15rem;
  color: var(--text-body);
  font-size: 16px;
  line-height: 1.75;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.answer li::marker {
  color: var(--secondary);
}
.answer {
}
.answer strong,
.answer b {
  color: var(--text-dark);
  font-weight: 700;
}
.answer em,
.answer i {
  font-style: italic;
}
.answer {
}
.answer a {
  color: var(--primary);
  font-weight: 500;
  text-decoration: none;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.answer a:hover {
  color: var(--primary-dark);
  text-decoration: underline;
}
.answer {
}
.answer hr {
  margin: 1.25rem 0;
  border: 0;
  border-top: 1px solid var(--border);
}
.answer {
}
.answer code {
  display: inline;
  padding: 2px 6px;
  border: 1px solid #e5e7eb;
  border-radius: 5px;
  background: #f8fafc;
  color: #be123c;
  font-family:
    Consolas,
    "Courier New",
    monospace;
  font-size: 0.9em;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.answer {
}
.answer pre {
  width: 100%;
  max-width: 100%;
  margin: 1rem 0;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 12px;
  background: #111827;
  color: #f9fafb;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: pre;
  -webkit-overflow-scrolling: touch;
}
.answer pre code {
  display: block;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  font-family:
    Consolas,
    "Courier New",
    monospace;
  font-size: 14px;
  line-height: 1.65;
  white-space: pre;
  overflow-wrap: normal;
  word-break: normal;
}
.answer {
}
.answer blockquote {
  width: 100%;
  max-width: 100%;
  margin: 1rem 0;
  padding: 10px 16px;
  box-sizing: border-box;
  border-left: 4px solid var(--primary);
  border-radius: 0 8px 8px 0;
  background: var(--primary-soft);
  color: #475569;
  font-style: italic;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: pre-wrap;
}
.answer {
}
.answer table {
  display: block;
  width: 100%;
  max-width: 100%;
  margin: 1.1rem 0;
  border-collapse: collapse;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: normal;
  -webkit-overflow-scrolling: touch;
}
.answer thead,
.answer tbody {
  width: 100%;
}
.answer th,
.answer td {
  min-width: 120px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  color: var(--text-body);
  font-size: 14px;
  line-height: 1.55;
  text-align: left;
  vertical-align: top;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.answer th {
  background: #f8fafc;
  color: var(--text-dark);
  font-weight: 700;
}
.answer tr:nth-child(even) td {
  background: #fafbfc;
}
.answer {
}
.answer img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 12px 0;
  border-radius: 10px;
  border: 1px solid var(--border);
}
.edit-wrapper {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
}
.edit-input {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 110px;
  padding: 13px 14px;
  box-sizing: border-box;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: #ffffff;
  color: var(--text-dark);
  outline: none;
  resize: vertical;
  font-family: inherit;
  font-size: 15px;
  line-height: 1.6;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.edit-input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.12);
}
.edit-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}
.cancel-btn,
.submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 38px;
  padding: 8px 16px;
  border-radius: 9px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}
.cancel-btn:active,
.submit-btn:active {
  transform: scale(0.97);
}
.cancel-btn {
  border: 1px solid var(--border);
  background: #ffffff;
  color: var(--text-secondary);
}
.cancel-btn:hover {
  background: #f8fafc;
  color: var(--text-dark);
}
.submit-btn {
  border: 1px solid var(--primary);
  background: var(--primary);
  color: #ffffff;
}
.submit-btn:hover {
  background: var(--primary-dark);
  border-color: var(--primary-dark);
}
.actions {
  display: flex;
  align-items: center;
  margin-top: 14px;
  padding-top: 4px;
}
.actions .message-actions {
  display: flex;
  align-items: center;
  gap: 5px;
}
.actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.actions button i {
  color: var(--text-secondary);
  font-size: 15px;
  transition: color 0.2s ease;
}
.actions button:hover {
  background: var(--primary-light);
  border-color: #dbe3f7;
}
.actions button:hover i {
  color: var(--primary);
}
.actions button:active {
  transform: scale(0.95);
}
.actions button.active {
  background: var(--primary);
}
.actions button.active i {
  color: #ffffff;
}
.actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.time {
  margin-top: 7px;
  padding-left: 4px;
  color: var(--text-muted);
  font-size: 12px;
  line-height: 1.4;
}
.ai-loader-container {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 28px;
}
.ai-loader {
  width: 42px;
  height: 42px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ai-loader .ai-loader-ring {
  position: absolute;
  width: 34px;
  height: 34px;
  border: 3px solid rgba(37, 59, 128, 0.15);
  border-top-color: #253b80;
  border-right-color: #344f91;
  border-radius: 50%;
  animation: ai-spin 0.9s linear infinite;
}
.ai-loader .ai-loader-core {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #253b80;
  box-shadow: 0 0 0 0 rgba(37, 59, 128, 0.35);
  animation: ai-pulse 1.4s ease-in-out infinite;
}
@keyframes ai-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes ai-pulse {
  0%, 100% {
    transform: scale(0.75);
    opacity: 0.7;
    box-shadow: 0 0 0 0 rgba(37, 59, 128, 0.25);
  }
  50% {
    transform: scale(1);
    opacity: 1;
    box-shadow: 0 0 0 8px rgba(37, 59, 128, 0);
  }
}
.thinking-text {
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  animation: thinkingBlink 1.5s infinite;
}
.typing::after {
  content: "";
  margin-left: 2px;
  color: var(--primary);
  font-weight: 700;
  animation: cursorBlink 0.8s infinite;
}
.source-label {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 16px;
  padding: 9px 12px;
  background: #f8fafc;
}
.source-label h5 {
  margin: 0;
  color: var(--text-dark);
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}
.source-label p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 1.5;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.source-wrapper {
  width: 100%;
  max-width: 100%;
  margin-top: 12px;
}
.source-wrapper .source-card {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: 13px;
  background: #ffffff;
  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.03);
}
.source-wrapper .source-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px 15px;
  background: #fafbfe;
  border-bottom: 1px solid #eef0f4;
}
.source-wrapper .source-title {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}
.source-wrapper .source-title i {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--primary-light);
  color: var(--primary);
  font-size: 14px;
}
.source-wrapper .source-title span {
  min-width: 0;
  color: var(--text-dark);
  font-size: 14px;
  font-weight: 650;
  line-height: 1.4;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.source-wrapper .toggle-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  flex-shrink: 0;
  min-height: 34px;
  padding: 7px 12px;
  border: 1px solid #dce4f5;
  border-radius: 8px;
  background: var(--primary-light);
  color: var(--primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.source-wrapper .toggle-btn:hover {
  background: #e1e7f8;
  border-color: #cbd5eb;
  transform: translateY(-1px);
}
.source-wrapper .toggle-btn:active {
  transform: translateY(0);
}
.source-wrapper .toggle-btn i {
  font-size: 11px;
  transition: transform 0.2s ease;
}
.source-wrapper .source-content {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: max-height 0.35s ease, opacity 0.25s ease;
}
.source-wrapper .source-content.show {
  max-height: 600px;
  overflow-y: auto;
  opacity: 1;
}
.source-wrapper .source-content::-webkit-scrollbar {
  width: 6px;
}
.source-wrapper .source-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.source-wrapper .source-content::-webkit-scrollbar-track {
  background: transparent;
}
.source-wrapper .source-text {
  padding: 17px;
  color: var(--text-body);
  font-size: 14px;
  line-height: 1.75;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.source-wrapper .source-text p {
  margin: 0 0 12px;
}
.source-wrapper .source-text p:last-child {
  margin-bottom: 0;
}
.source-wrapper .source-text strong {
  color: var(--text-dark);
  font-weight: 700;
}
.source-wrapper .source-text a {
  color: var(--primary);
  text-decoration: none;
}
.source-wrapper .source-text a:hover {
  text-decoration: underline;
}
.source-wrapper .source-text code {
  padding: 2px 6px;
  border: 1px solid var(--border);
  border-radius: 5px;
  background: #f8fafc;
  color: var(--text-dark);
  font-size: 13px;
}
.source-item {
  margin-bottom: 12px;
  color: var(--text-body);
  font-size: 14px;
  line-height: 1.65;
  padding: 20px;
}
.source-item:last-child {
  margin-bottom: 0;
}
.source-doc {
  color: var(--primary);
  font-size: 13px;
  font-weight: 600;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.feedback-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background: rgba(15, 23, 42, 0.48);
  z-index: 9999;
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
.feedback-popup {
  position: relative;
  width: 440px;
  max-width: calc(100vw - 32px);
  box-sizing: border-box;
  padding: 22px;
  border: 1px solid var(--border);
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
  animation: popupIn 0.2s ease-out;
}
.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}
.popup-header h4 {
  margin: 0;
  color: var(--text-dark);
  font-size: 17px;
  font-weight: 700;
}
.popup-header .close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: #f8fafc;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.popup-header .close-btn:hover {
  background: #eef2f7;
}
.popup-header .close-btn:hover i {
  color: var(--text-dark);
}
.popup-header .close-btn i {
  color: var(--text-secondary);
  font-size: 14px;
}
.feedback-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}
.feedback-options button {
  min-height: 38px;
  padding: 7px 13px;
  border: 1px solid #d1d5db;
  border-radius: 9px;
  background: #ffffff;
  color: var(--text-body);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
}
.feedback-options button:hover {
  background: var(--primary-light);
  border-color: #cbd5e1;
  color: var(--primary);
}
.feedback-options button.selected {
  background: var(--primary-light);
  border-color: var(--primary);
  color: var(--primary);
  font-weight: 650;
}
.feedback-popup textarea {
  display: block;
  width: 100%;
  min-height: 100px;
  box-sizing: border-box;
  padding: 12px 13px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #ffffff;
  color: var(--text-dark);
  outline: none;
  resize: vertical;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.6;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.feedback-popup textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.1);
}
.feedback-popup textarea::placeholder {
  color: var(--text-muted);
}
.popup-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 18px;
}
.popup-footer button {
  min-width: 90px;
  min-height: 40px;
  padding: 8px 16px;
  border-radius: 9px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}
.popup-footer button:active {
  transform: scale(0.97);
}
.popup-footer .cancel-btn {
  border: 1px solid var(--border);
  background: #ffffff;
  color: var(--text-secondary);
}
.popup-footer .cancel-btn:hover {
  background: #f8fafc;
  color: var(--text-dark);
}
.popup-footer .submit-btn {
  border: 1px solid var(--primary);
  background: var(--primary);
  color: #ffffff;
}
.popup-footer .submit-btn:hover {
  background: var(--primary-dark);
  border-color: var(--primary-dark);
}
:host ::ng-deep .small-tooltip {
  font-size: 12px;
}
:host ::ng-deep .small-tooltip .p-tooltip-text {
  max-width: 180px;
  padding: 7px 10px;
  font-size: 11px;
  line-height: 1.3;
}
:host ::ng-deep .small-tooltip .p-tooltip-arrow {
  transform: scale(0.8);
}
:host ::ng-deep .p-dialog {
  display: flex;
  flex-direction: column;
  width: min(720px, 100vw - 32px);
  max-width: calc(100vw - 32px);
  max-height: 90vh;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 16px;
}
:host ::ng-deep .p-dialog .p-dialog-header {
  padding: 18px 22px;
  border-bottom: 1px solid var(--border);
  background: #ffffff;
}
:host ::ng-deep .p-dialog .p-dialog-header .p-dialog-title {
  color: var(--text-dark);
  font-size: 18px;
  font-weight: 700;
}
:host ::ng-deep .p-dialog .p-dialog-content {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 18px 22px;
  overflow-x: hidden;
  overflow-y: auto;
  background: #ffffff;
}
:host ::ng-deep .p-dialog .p-dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  gap: 8px;
  padding: 13px 22px;
  box-sizing: border-box;
  border-top: 1px solid var(--border);
  background: #ffffff;
}
:host ::ng-deep .p-dialog .p-dialog-footer .p-button {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  min-height: 40px;
  margin: 0;
  padding: 8px 16px;
  box-sizing: border-box;
  border-radius: 9px;
  font-size: 14px;
  font-weight: 600;
}
:host ::ng-deep .p-dialog .p-dialog-footer .save-btn {
  border: 1px solid var(--primary) !important;
  background: var(--primary) !important;
  color: #ffffff !important;
}
:host ::ng-deep .p-dialog .p-dialog-footer .save-btn:hover {
  background: var(--primary-dark) !important;
  border-color: var(--primary-dark) !important;
}
:host ::ng-deep .p-dialog .p-dialog-footer .cancel-btn {
  margin-right: 0;
  border: 1px solid var(--border) !important;
  background: #ffffff !important;
  color: var(--text-secondary) !important;
}
:host ::ng-deep .p-dialog .p-dialog-footer .cancel-btn:hover {
  background: #f8fafc !important;
  color: var(--text-dark) !important;
}
:host ::ng-deep .p-editor {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
}
:host ::ng-deep .p-editor .p-editor-toolbar {
  border: 0;
  border-bottom: 1px solid var(--border);
  background: #f8fafc;
}
:host ::ng-deep .p-editor .p-editor-content {
  border: 0;
}
:host ::ng-deep .p-editor .p-editor-content .ql-editor {
  min-height: 280px;
  padding: 14px 16px;
  color: var(--text-body);
  font-family: inherit;
  font-size: 15px;
  line-height: 1.7;
}
:host ::ng-deep .p-editor .p-editor-content .ql-editor:focus {
  outline: none;
}
:host ::ng-deep .p-editor .p-editor-content .ql-editor p {
  margin-bottom: 0.75rem;
}
:host ::ng-deep .p-dialog,
:host ::ng-deep .p-dialog-content,
:host ::ng-deep .p-dialog-footer {
  overflow-x: hidden;
}
@keyframes cursorBlink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
@keyframes thinkingBlink {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
@keyframes popupIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 768px) {
  .chat-wrapper {
    padding: 14px;
  }
  .chat-block {
    max-width: 88%;
  }
  .chat-card {
    padding: 15px 17px;
  }
  .user-card {
    font-size: 15px;
  }
  .answer {
    font-size: 15px;
  }
  .answer ::ng-deep p,
  .answer ::ng-deep li {
    font-size: 15px;
  }
  .source-wrapper .source-header {
    padding: 12px 14px;
  }
  .source-wrapper .source-title span {
    font-size: 13px;
  }
  .source-wrapper .toggle-btn {
    min-height: 32px;
    padding: 6px 10px;
    font-size: 12px;
  }
  .source-wrapper .source-text {
    padding: 14px;
    font-size: 14px;
    line-height: 1.7;
  }
}
@media (max-width: 576px) {
  .chat-wrapper {
    padding: 10px;
  }
  .chat-row {
    gap: 9px;
    margin-bottom: 20px;
  }
  .chat-block {
    max-width: calc(100% - 47px);
  }
  .chat-card {
    padding: 12px 14px;
  }
  .user-card {
    max-width: 100%;
    font-size: 15px;
    border-radius: 16px 16px 4px 16px;
  }
  .bot-card {
    border-radius: 5px 16px 16px 16px;
  }
  .question-text {
    font-size: 15px;
  }
  .question-actions {
    opacity: 1;
    visibility: visible;
  }
  .answer {
    font-size: 15px;
    line-height: 1.72;
  }
  .answer ::ng-deep h1 {
    font-size: 1.3rem;
  }
  .answer ::ng-deep h2 {
    font-size: 1.15rem;
  }
  .answer ::ng-deep h3 {
    font-size: 1.05rem;
  }
  .answer ::ng-deep p,
  .answer ::ng-deep li {
    font-size: 15px;
  }
  .answer ::ng-deep ul,
  .answer ::ng-deep ol {
    padding-left: 1.4rem;
  }
  .answer ::ng-deep pre {
    padding: 12px;
    border-radius: 9px;
  }
  .answer ::ng-deep pre code {
    font-size: 13px;
  }
  .answer ::ng-deep th,
  .answer ::ng-deep td {
    min-width: 110px;
    padding: 7px 9px;
    font-size: 13px;
  }
  .avatar {
    width: 34px;
    height: 34px;
    min-width: 34px;
    flex-basis: 34px;
  }
  .actions {
    margin-top: 11px;
  }
  .actions .message-actions {
    gap: 4px;
  }
  .actions button {
    width: 34px;
    height: 34px;
  }
  .source-wrapper .source-header {
    align-items: flex-start;
    padding: 11px 12px;
  }
  .source-wrapper .source-title {
    gap: 7px;
  }
  .source-wrapper .source-title i {
    width: 26px;
    height: 26px;
  }
  .source-wrapper .source-title span {
    font-size: 13px;
  }
  .source-wrapper .toggle-btn {
    min-height: 31px;
    padding: 6px 9px;
    font-size: 11px;
  }
  .source-wrapper .source-text {
    padding: 13px;
    font-size: 13px;
  }
  .feedback-popup {
    width: calc(100vw - 24px);
    max-width: calc(100vw - 24px);
    padding: 17px;
  }
  :host ::ng-deep .p-dialog {
    width: calc(100vw - 20px);
    max-width: calc(100vw - 20px);
    max-height: 92vh;
    border-radius: 14px;
  }
  :host ::ng-deep .p-dialog .p-dialog-header {
    padding: 15px 16px;
  }
  :host ::ng-deep .p-dialog .p-dialog-header .p-dialog-title {
    font-size: 16px;
  }
  :host ::ng-deep .p-dialog .p-dialog-content {
    padding: 14px;
  }
  :host ::ng-deep .p-dialog .p-dialog-footer {
    gap: 7px;
    padding: 10px 14px;
  }
  :host ::ng-deep .p-dialog .p-dialog-footer .p-button {
    min-width: 78px;
    min-height: 38px;
    padding: 7px 12px;
  }
  :host ::ng-deep .p-editor .p-editor-content .ql-editor {
    min-height: 220px;
    font-size: 14px;
  }
}
@media (max-width: 480px) {
  .chat-wrapper {
    padding: 8px;
  }
  .chat-row {
    gap: 7px;
    margin-bottom: 17px;
  }
  .chat-block {
    max-width: calc(100% - 41px);
  }
  .chat-card {
    padding: 10px 12px;
  }
  .avatar {
    width: 32px;
    height: 32px;
    min-width: 32px;
    flex-basis: 32px;
  }
  .question-text {
    font-size: 14px;
    line-height: 1.6;
  }
  .answer {
    font-size: 14px;
  }
  .answer ::ng-deep h1 {
    font-size: 1.15rem;
  }
  .answer ::ng-deep h2 {
    font-size: 1.05rem;
  }
  .answer ::ng-deep h3 {
    font-size: 0.98rem;
  }
  .answer ::ng-deep p,
  .answer ::ng-deep li {
    font-size: 14px;
    line-height: 1.7;
  }
  .answer ::ng-deep table {
    font-size: 12px;
  }
  .answer ::ng-deep th,
  .answer ::ng-deep td {
    min-width: 100px;
    padding: 6px 8px;
    font-size: 12px;
  }
  .icon-btn {
    width: 30px;
    height: 30px;
    min-width: 30px;
  }
  .source-wrapper .source-header {
    flex-direction: column;
    align-items: stretch;
    gap: 9px;
  }
  .source-wrapper .toggle-btn {
    align-self: flex-start;
  }
  .popup-footer button {
    min-width: 78px;
    padding: 7px 12px;
  }
}
button:focus-visible,
textarea:focus-visible,
.edit-input:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}
.ai-suggestions {
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}
.suggestion-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border: 1px solid #d9dee8;
  border-radius: 20px;
  background: #fff;
  color: #253b80;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    transform 0.15s ease;
}
.suggestion-btn:hover:not(:disabled) {
  background: #f4f6fa;
  border-color: #253b80;
  transform: translateY(-1px);
}
.suggestion-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.suggestion-btn i {
  font-size: 13px;
}
.ai-suggestions {
  margin-top: 14px;
  padding: 14px;
  border-radius: 14px;
  background: #f8fafc;
}
.ai-suggestions .suggestions-label {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 10px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}
.ai-suggestions .suggestions-label i {
  color: #f59e0b;
  font-size: 14px;
}
.ai-suggestions .suggestions-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.ai-suggestions .suggestion-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 38px;
  max-width: 100%;
  padding: 8px 12px;
  border: 1px solid #dbe3ef;
  border-radius: 10px;
  background: #fff;
  color: #253b80;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.15s ease;
}
.ai-suggestions .suggestion-btn .suggestion-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ai-suggestions .suggestion-btn i {
  flex-shrink: 0;
  font-size: 11px;
  transition: transform 0.2s ease;
}
.ai-suggestions .suggestion-btn:hover:not(:disabled) {
  border-color: #253b80;
  background: #f1f5ff;
  box-shadow: 0 3px 10px rgba(37, 59, 128, 0.08);
}
.ai-suggestions .suggestion-btn:hover:not(:disabled) i {
  transform: translateX(3px);
}
.ai-suggestions .suggestion-btn:active:not(:disabled) {
  transform: scale(0.98);
}
.ai-suggestions .suggestion-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
:host ::ng-deep .edit-answer-wrapper .p-editor-toolbar {
  background: #f8fafc;
  border-radius: 6px 6px 0 0;
}
:host ::ng-deep .edit-answer-wrapper .p-editor-toolbar button {
  position: relative;
  cursor: pointer;
}
:host ::ng-deep .edit-answer-wrapper .p-editor-content {
  border-radius: 0 0 6px 6px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.formatted-answer {
  line-height: 1.7;
  overflow-wrap: anywhere;
}
.formatted-answer h2,
.formatted-answer h3,
.formatted-answer h4 {
  margin: 16px 0 8px;
  font-weight: 600;
}
.formatted-answer p {
  margin-bottom: 12px;
}
.formatted-answer ul,
.formatted-answer ol {
  padding-left: 24px;
  margin: 8px 0 16px;
}
.formatted-answer table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0;
}
.formatted-answer th,
.formatted-answer td {
  border: 1px solid #dee2e6;
  padding: 8px 12px;
  text-align: left;
}
.formatted-answer th {
  background: #f1f4f9;
  font-weight: 600;
}
.formatted-answer pre,
.formatted-answer code {
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
.formatted-answer a {
  color: #253b80;
  text-decoration: underline;
}
.answer-content {
  width: 100%;
  color: #333;
  font-size: 14px;
  line-height: 1.8;
  overflow-wrap: anywhere;
}
.answer-content p {
  margin: 0 0 14px;
}
.answer-content h2,
.answer-content h3,
.answer-content h4 {
  color: #253b80;
  font-weight: 600;
  margin: 20px 0 12px;
}
.answer-content strong,
.answer-content b {
  font-weight: 700;
}
.answer-content ul,
.answer-content ol {
  padding-left: 26px;
  margin: 10px 0 18px;
}
.answer-content li {
  margin-bottom: 7px;
}
.answer-content code {
  background: #f0f1f3;
  color: #b42318;
  border-radius: 4px;
  padding: 2px 5px;
}
.answer-content pre {
  padding: 14px;
  background: #f3f4f6;
  border-radius: 8px;
  overflow-x: auto;
  white-space: pre-wrap;
}
.answer-content pre code {
  background: transparent;
  color: inherit;
  padding: 0;
}
.answer-content .answer-table-wrapper {
  display: block;
  width: 100%;
  margin: 16px 0;
  overflow-x: auto;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  -webkit-overflow-scrolling: touch;
}
.answer-content .answer-table {
  width: 100%;
  min-width: 500px;
  border-collapse: collapse;
  background: #fff;
  font-size: 14px;
  line-height: 1.6;
}
.answer-content .answer-table th,
.answer-content .answer-table td {
  padding: 10px 14px;
  text-align: left;
  vertical-align: top;
  border: 1px solid #d9dee7;
}
.answer-content .answer-table thead th {
  background: #e9edf3;
  color: #25324b;
  font-weight: 700;
}
.answer-content .answer-table tbody tr:nth-child(odd) {
  background: #f3f4f6;
}
.answer-content .answer-table tbody tr:nth-child(even) {
  background: #fff;
}
.answer-content blockquote {
  margin: 14px 0;
  padding: 10px 16px;
  border-left: 4px solid #253b80;
  background: #f3f4f6;
}
.answer-content hr {
  border: 0;
  border-top: 1px solid #d1d5db;
  margin: 20px 0;
}
/*# sourceMappingURL=ai.component.css.map */
